import {
  QUICK_TEST_LOAD_LOCATION,
  QUICK_TEST_LOAD_SOURCE_LOCATION,
  QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND,
  QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK,
  QUICK_TEST_PREVIEW,
  QUICK_TEST_GET_BY_ID,
  QUICK_TEST_GET_LIST,
  QUICK_TEST_CREATE,
  QUICK_TEST_UPDATE,
  QUICK_TEST_DELETE,
  QUICK_TEST_EXPORT_EXCEL,
  QUICK_TEST_IMPORT_EXCEL,
  QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK_FOR_SEARCH,
  QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND_FOR_SEARCH,
  QUICK_TEST_EVALUATION_LOAD_DIVISION,
  QUICK_TEST_EVALUATION_LOAD_DEPARTMENT,
  QUICK_TEST_EVALUATION_LOAD_SECTION,
  QUICK_TEST_EVALUATION_LOAD_PLANT,
  QUICK_TEST_LOAD_SOURCE_LOCATION_FOR_CREATE,
  REMOVE_LISTS,
} from './actions'

const initialState = {
  // *load ข้อมูลโรงงานสำหรับ create
  location_list: [],
  check_location_list: false,

  // *load ข้อมูลต้นแหล่งสำหรับ create
  source_location_list_for_create: [],
  check_source_location_list_for_create: false,

  // *load ข้อมูลต้นแหล่งสำหรับค้นหา
  source_location_list: [],
  check_source_location_list: false,

  // *load ข้อมูลต้นแหล่งทราย
  sand_source_list: [],
  check_sand_source_list: false,

  // *load ข้อมูลต้นแหล่งหิน
  rock_source_list: [],
  check_rock_source_list: false,

  // *load ข้อมูล preview
  preview_list: [],
  check_preview_list: false,

  // *ดึงข้อมูล quick test by id
  quick_test_by_id: [],
  check_quick_test_by_id: false,

  // *ดึงรายการ Quick Test
  check_quick_test_list: false,
  quick_test_list: [],
  quick_test_list_total: 0,

  // *create ข้อมูล Quick Test
  quick_test_create: {},
  check_quick_test_create: false,

  // *update ข้อมูล Quick Test
  quick_test_update: {},
  check_quick_test_update: false,

  // *delete ข้อมูล Quick Test
  quick_test_delete: {},
  check_quick_test_delete: false,

  // *export excel
  quick_test_export_excel: {},
  check_quick_test_export_excel: false,

  // *import quicktest data
  quick_test_import_excel: {},
  check_quick_test_import_excel: false,

  // *load ข้อมูลต้นแหล่งหิน for search
  rock_source_list_for_search: [],
  check_rock_source_list_for_search: false,

  // *load ข้อมูลต้นแหล่งทราย for search
  sand_source_list_for_search: [],
  check_sand_source_list_for_search: false,

  // *loadข้อมูลสำหรับ filter
  division_list: [],
  check_division_list: false,

  department_list: [],
  check_department_list: false,

  section_list: [],
  check_section_list: false,

  plant_list: [],
  check_plant_list: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState
    case QUICK_TEST_LOAD_LOCATION.REQUEST:
      return {
        ...state,
        location_list: [],
        check_location_list: true,
      }
    case QUICK_TEST_LOAD_LOCATION.SUCCESS:
      return {
        ...state,
        location_list: action.payload.lists || [],
        check_location_list: false,
      }

    case QUICK_TEST_LOAD_SOURCE_LOCATION.REQUEST:
      return {
        ...state,
        source_location_list: [],
        check_source_location_list: true,
      }

    case QUICK_TEST_LOAD_SOURCE_LOCATION.SUCCESS:
      return {
        ...state,
        source_location_list: action.payload.lists || [],
        check_source_location_list: false,
      }

    case QUICK_TEST_LOAD_SOURCE_LOCATION_FOR_CREATE.REQUEST:
      return {
        ...state,
        source_location_list_for_create: [],
        check_source_location_list_for_create: true,
      }

    case QUICK_TEST_LOAD_SOURCE_LOCATION_FOR_CREATE.SUCCESS:
      return {
        ...state,
        source_location_list_for_create: action.payload.lists || [],
        check_source_location_list_for_create: false,
      }

    case QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND.REQUEST:
      return {
        ...state,
        sand_source_list: [],
        check_sand_source_list: true,
      }
    case QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND.SUCCESS:
      return {
        ...state,
        sand_source_list: action.payload.lists || [],
        check_sand_source_list: false,
      }
    case QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK.REQUEST:
      return {
        ...state,
        rock_source_list: [],
        check_rock_source_list: true,
      }
    case QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK.SUCCESS:
      return {
        ...state,
        rock_source_list: action.payload.lists || [],
        check_rock_source_list: false,
      }

    case QUICK_TEST_PREVIEW.REQUEST:
      return {
        ...state,
        preview_list: [],
        check_preview_list: true,
      }
    case QUICK_TEST_PREVIEW.SUCCESS:
      return {
        ...state,
        preview_list: action.payload.lists || [],
        check_preview_list: false,
      }
    case QUICK_TEST_GET_BY_ID.REQUEST:
      return {
        ...state,
        quick_test_by_id: [],
        check_quick_test_by_id: true,
      }
    case QUICK_TEST_GET_BY_ID.SUCCESS:
      return {
        ...state,
        quick_test_by_id: action.payload.lists.data || [],
        check_quick_test_by_id: false,
      }

    case QUICK_TEST_GET_LIST.REQUEST:
      return {
        ...state,
        check_quick_test_list: true,
        quick_test_list_total: 0,
      }
    case QUICK_TEST_GET_LIST.SUCCESS:
      return {
        ...state,
        check_quick_test_list: false,
        quick_test_list: action.payload.lists.data || [],
        quick_test_list_total: action.payload.lists.total || 0,
      }
    case QUICK_TEST_CREATE.REQUEST:
      return {
        ...state,
        quick_test_create: {},
        check_quick_test_create: true,
      }
    case QUICK_TEST_CREATE.SUCCESS:
      return {
        ...state,
        quick_test_create: action.payload.lists || {},
        check_quick_test_create: false,
      }
    case QUICK_TEST_UPDATE.REQUEST:
      return {
        ...state,
        quick_test_update: {},
        check_quick_test_update: true,
      }
    case QUICK_TEST_UPDATE.SUCCESS:
      return {
        ...state,
        quick_test_update: action.payload.lists || {},
        check_quick_test_update: false,
      }
    case QUICK_TEST_DELETE.REQUEST:
      return {
        ...state,
        quick_test_delete: {},
        check_quick_test_delete: true,
      }
    case QUICK_TEST_DELETE.SUCCESS:
      return {
        ...state,
        quick_test_delete: action.payload.lists || {},
        check_quick_test_delete: false,
      }
    case QUICK_TEST_EXPORT_EXCEL.REQUEST:
      return {
        ...state,
        quick_test_export_excel: {},
        check_quick_test_export_excel: true,
      }
    case QUICK_TEST_EXPORT_EXCEL.SUCCESS:
      return {
        ...state,
        quick_test_export_excel: action.payload.lists || {},
        check_quick_test_export_excel: false,
      }

    case QUICK_TEST_IMPORT_EXCEL.REQUEST:
      return {
        ...state,
        quick_test_import_excel: {},
        check_quick_test_import_excel: true,
      }

    case QUICK_TEST_IMPORT_EXCEL.SUCCESS:
      return {
        ...state,
        quick_test_import_excel: action.payload.lists || {},
        check_quick_test_import_excel: false,
      }
    case QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK_FOR_SEARCH.REQUEST:
      return {
        ...state,
        rock_source_list_for_search: [],
        check_rock_source_list_for_search: true,
      }
    case QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK_FOR_SEARCH.SUCCESS:
      return {
        ...state,
        rock_source_list_for_search: action.payload.lists || [],
        check_rock_source_list_for_search: false,
      }
    case QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND_FOR_SEARCH.REQUEST:
      return {
        ...state,
        sand_source_list_for_search: [],
        check_sand_source_list_for_search: true,
      }
    case QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND_FOR_SEARCH.SUCCESS:
      return {
        ...state,
        sand_source_list_for_search: action.payload.lists || [],
        check_sand_source_list_for_search: false,
      }

    case QUICK_TEST_EVALUATION_LOAD_DIVISION.REQUEST:
      return {
        ...state,
        division_list: [],
        check_division_list: true,
      }
    case QUICK_TEST_EVALUATION_LOAD_DIVISION.SUCCESS:
      return {
        ...state,
        division_list: action.payload.lists,
        check_division_list: false,
      }
    case QUICK_TEST_EVALUATION_LOAD_DEPARTMENT.REQUEST:
      return {
        ...state,
        department_list: [],
        check_department_list: true,
      }
    case QUICK_TEST_EVALUATION_LOAD_DEPARTMENT.SUCCESS:
      return {
        ...state,
        department_list: action.payload.lists,
        check_department_list: false,
      }
    case QUICK_TEST_EVALUATION_LOAD_SECTION.REQUEST:
      return {
        ...state,
        section_list: [],
        check_section_list: true,
      }
    case QUICK_TEST_EVALUATION_LOAD_SECTION.SUCCESS:
      return {
        ...state,
        section_list: action.payload.lists,
        check_section_list: false,
      }
    case QUICK_TEST_EVALUATION_LOAD_PLANT.REQUEST:
      return {
        ...state,
        plant_list: [],
        check_plant_list: true,
      }
    case QUICK_TEST_EVALUATION_LOAD_PLANT.SUCCESS:
      return {
        ...state,
        plant_list: action.payload.lists,
        check_plant_list: false,
      }

    default:
      return state
  }
}
